import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import React from "react";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { useCallsByDoctorStatsQuery } from "../../graphql";

function toMinutes(sec: number): number {
  return Math.round(sec / 60);
}

const CallsByDoctorReport: React.FC = () => {
  const { data, loading } = useCallsByDoctorStatsQuery();

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
        <Title title="Telefonata sipas mjekëve gjatë muajit të kaluar"></Title>

        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Mjeku</Th>
              <Th isNumeric width={"20%"}>
                Telefonata të kryera
              </Th>
              <Th isNumeric width={"20%"}>
                Minuta
              </Th>
              <Th isNumeric width={"20%"}>
                Telefonata të humbura
              </Th>
              <Th isNumeric width={"20%"}>
                Telefonata të mbyllura
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.callsByDoctorStats.callsByDoctor.map((item) => (
              <Tr>
                <Td>{item.doctorName}</Td>
                <Td isNumeric>{item.info.callsSuccess}</Td>
                <Td isNumeric>{toMinutes(item.info.callsMinutes)}</Td>
                <Td isNumeric>{item.info.callsExpired}</Td>
                <Td isNumeric>{item.info.callsClosed}</Td>
              </Tr>
            ))}
            <Tr fontWeight={"bold"}>
              <Td>Totali</Td>
              <Td isNumeric>
                {data.callsByDoctorStats.totalCalls.callsSuccess}
              </Td>
              <Td isNumeric>
                {toMinutes(data.callsByDoctorStats.totalCalls.callsMinutes)}
              </Td>
              <Td isNumeric>
                {data.callsByDoctorStats.totalCalls.callsExpired}
              </Td>
              <Td isNumeric>
                {data.callsByDoctorStats.totalCalls.callsClosed}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default CallsByDoctorReport;
